import {ExpenseType} from '../expenseType';

export function toString(this: ExpenseType) {
    return `Deal: ${this.id}`;
}
